export default "__VITE_ASSET__DhkcmTgJ__"